import Vue from "vue";
import axios from "axios";

const Http = {};

// axios.defaults.baseURL = "http://47.92.2.108:9909";
// axios.defaults.baseURL = baseUrl;

axios.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = localStorage.getItem("token");
    return config;
  },
  (error) => {
    console.log(error, "err");
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    if (response.data.status == 1003) {
      localStorage.removeItem("token");
      router.replace("/login?type=" + localStorage.getItem("type"));
      location.reload();
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Http.post = function (url, param = {}, type) {
  // let baseURL = "http://8.130.75.122:9909";
  // if (type == "amoi") {
  //    baseURL = "http://amoi.tpddns.cn:8088";
  // }
  // let baseURL = "http://180.101.238.86:18080";
  let baseURL = baseUrl
  return new Promise((resolve, reject) => {
    axios
      .post(baseURL + url, param)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

Http.get = function (url, param = {}, type) {
  // let baseURL = "http://8.130.75.122:9909";
  // if (type == "amoi") {
    // let baseURL = "http://180.101.238.86:18080";
  // }
  let baseURL = baseUrl
  return new Promise((resolve, reject) => {
    axios
      .get(baseURL + url, {
        params: param,
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

Vue.prototype.$axios = Http;
export default Http;
